import Hero from './sections/Hero';
import SupportedFormats from './sections/SupportedFormats';
import NotesFeatures from './sections/NotesFeatures';
import NotesHowItWorks from './sections/HowItWorks';

const InteractiveNotes = () => {
  return (
    <>
      <Hero />
      <SupportedFormats />
      <NotesFeatures />
      <NotesHowItWorks />
    </>
  );
};

export default InteractiveNotes;
